import { lazy } from "react";

const AllNotifications = lazy(() => import("../../../pages/User/notifications/AllNotifications"));
const NotificationDetail = lazy(() => import("../../../pages/User/notifications/NotificationDetails"));

export const notificationRoutes = [
  { path: "notifications", element: <AllNotifications /> },
  { path: "notifications/:id", element: <NotificationDetail /> },
];
